import defaultState from './defaultState'

const unwrapState = state => state.user || defaultState

export const isLoggedIn = state => unwrapState(state).loggedIn
export const getUserInfo = state => unwrapState(state).info
export const getUserEmail = state => (getUserInfo(state) || {}).email
export const isUserStaff = state => (getUserInfo(state) || {}).is_staff
